import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=b27db674&scoped=true&"
import script from "./Picture.vue?vue&type=script&lang=js&"
export * from "./Picture.vue?vue&type=script&lang=js&"
import style0 from "./Picture.vue?vue&type=style&index=0&id=b27db674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27db674",
  null
  
)

export default component.exports